import * as C from './styles';
import { doc, getFirestore, setDoc } from 'firebase/firestore';
import { useEffect, useState } from 'react';
import { AppFirebase } from '../../../../config/firebase';
import bcrypt, { hash } from "bcryptjs";
import { useNavigate } from 'react-router-dom';

export default function NewProfile({ profileSettings, user, getProfiles, newProfile, setNewProfile, profilesLength, cancelNewProfile }) {

    const uuid = require('uuid');

    const [ name, setName ] = useState('');
    const [ msgErro, setMsgErro ] = useState();

    const [ colorImage, setColorImage ] = useState('azul');

    const navigate = useNavigate();

    const database = getFirestore(AppFirebase);

    useEffect(() => {
        
        if (!newProfile) {
            setName('')
        }

    }, [ newProfile ]);
    
    const addNewProfile = async (e) => {
        
        e.preventDefault();
        if (name) {

            if (name.length < 3 || name.length > 15) {

                if (name && name.length > 15) {
                    setMsgErro('O nome deve conter no máximo 15 caracteres');
                } else if (name && name.length < 3) {
                    setMsgErro('O nome deve conter no mínimo 3 caracteres');
                }
            } else {
                setUserDB();
            }
        }
        
        setTimeout(()=> {
            setMsgErro();
        }, 5000);

    }

    const setUserDB = async ()=> {

        const profileUid =  uuid.v4();
    
        await setDoc(doc(database, `/profiles/${profileUid}`), {
            profile_name: name,
            profile_photo_url: `https://firebasestorage.googleapis.com/v0/b/dflix-f2014.appspot.com/o/imgs-perfil-user%2Fdflix%2Fhappy-${colorImage}.svg?alt=media&token=0df77cd2-26f5-41b6-a1a0-193f0d3686d6`,
            profile_created: new Date(),
            profile_primary: (profilesLength >= 1 ? false : true),
            profile_uid: profileUid,
            account_email: user.email,
            account_uid: user.uid
        });

        if (profileSettings) {
            navigate('/settings/account');
        } else {
            setNewProfile(false);
            getProfiles(user.uid);
        }
    };

    return(
        <C.Container>
            <header>
                <h2 className='title-welcome'>Criar perfil</h2>
                <h4>adicione um novo perfil a sua conta</h4>
            </header>

            <form method='' action='' onSubmit={addNewProfile} className='form-login-cadastrar'>
                <div>
                    <section className='section-new-profile'>
                        <section className='section-image-color'>
                            <button type='button' onClick={()=>setColorImage(colorImage == 'azul' ? 'violeta' : 'azul')}><i className="fa-solid fa-repeat"></i></button>
                            <img src={`https://firebasestorage.googleapis.com/v0/b/dflix-f2014.appspot.com/o/imgs-perfil-user%2Fdflix%2Fhappy-${colorImage}.svg?alt=media&token=0df77cd2-26f5-41b6-a1a0-193f0d3686d6`} alt='avatar' />
                        </section>
                        <div className='div-input-new-profile'>
                            <input required type='text' value={name} placeholder='Nome' onChange={(e)=>setName(e.target.value)}/>
                            <span>{user.email}</span>
                        </div>
                    </section>
                </div>
                <section className='section-bts-add-profile'>
                    <button type='submit'>Criar Perfil</button>
                    {!profilesLength >= 1 &&
                        <button type='button' onClick={cancelNewProfile}>Sair da conta</button>
                    }
                    {profilesLength >= 1 &&
                        <button type='button' onClick={cancelNewProfile}>Cancelar</button>
                    }
                </section>
                <p className='descricao-erro'>{msgErro}</p>
            </form>

        </C.Container>
    )
}